import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { ComponentStylingInterface, ImageComponentInterface } from '../../../../../interfaces/pagebuilder';
import { PageBuilderSettingsSection, PageBuilderSettingsTable } from '../PageBuilderSettingsTable';

const ImageStyling = ({ component, onChange }: ComponentStylingInterface<ImageComponentInterface>) => {
  const { t } = useTranslation();

  const [currComponent, setCurrComponent] = useState(component);

  useEffect(() => {
    setCurrComponent(component);
  }, [component]);

  function aspectFormToComponent(value: any) {
    const split = value.split(':');
    if (split.length === 2) {
      const x = parseInt(split[0]);
      const y = parseInt(split[1]);
      console.log(x);
      onChange({
        ...currComponent,
        customStyling: {
          ...currComponent.customStyling,
          aspectRatio: {
            x,
            y,
          },
        },
      });
    }
  }

  const settingSections: PageBuilderSettingsSection[] = [
    {
      settings: [
        {
          path: 'isFullWidth',
          type: 'boolean',
          label: t('pagebuilder:fullwidth'),
          defaultValue: currComponent?.isFullWidth,
        },
        {
          path: 'pagebuilder:customStyling.aspectRatio',
          type: 'select',
          label: t('pagebuilder:aspect-ratio'),
          selectItems: [
            { value: '1:1', name: '1:1' },
            { value: '3:1', name: '3:1' },
            { value: '3:2', name: '3:2' },
            { value: '4:1', name: '4:1' },
            { value: '4:3', name: '4:3' },
            { value: '5:9', name: '5:9' },
            { value: '16:9', name: '16:9' },
          ],
          defaultValue: currComponent?.customStyling?.aspectRatio
            ? `${currComponent?.customStyling?.aspectRatio?.x}:${currComponent?.customStyling?.aspectRatio?.y}`
            : '4:1',
          onChange: aspectFormToComponent,
          visible: currComponent.imageComponentType === 'slideshow',
        },
        {
          path: 'customStyling.width',
          type: 'number',
          label: t('pagebuilder:img-width'),
          defaultValue: currComponent?.customStyling.width,
          visible: currComponent.imageComponentType === 'image',
        },
        {
          path: 'customStyling.alignment',
          type: 'select',
          label: t('pagebuilder:img-alignment'),
          defaultValue: currComponent?.customStyling.alignment ?? 'center',
          selectItems: [
            { name: t('pagebuilder:center'), value: 'center' },
            { name: t('pagebuilder:left'), value: 'left' },
            { name: t('pagebuilder:right'), value: 'right' },
          ],
          visible: currComponent.imageComponentType === 'image',
        },
      ],
    },
  ];

  return <PageBuilderSettingsTable sections={settingSections} onChange={onChange} component={component} showTitleAndDescription={false} />;
};
export default ImageStyling;
